// 申报内容
import {
    Button,
    Col,
    DatePicker,
    Descriptions,
    Form,
    Input,
    Row,
    Space,
    Table,
    InputNumber,
    Typography,
    Select, Steps, Tag, App, Collapse
} from "antd";
import {useEffect, useState} from "react";
import {gql, useMutation, useSubscription} from "@apollo/client";
import {APIURL, 申报表主表所有万元金额字段, 近三年经营情况字段} from "./config";
import {bigIntMoney10000ToString, money10000ToString, string10000ToMoney} from "./Utils";
import {chatAI} from "./chatAI";
import {SelectUpload} from "./component/SelectUpload";
import {Attachments} from "./component/Attachments";
import {UploadOutlined} from "@ant-design/icons";

const {Title, Paragraph, Text, Link} = Typography;
const {TextArea} = Input;
const {Panel} = Collapse;
const onSearch = (value) => console.log(value);
const {Search} = Input;
export default function Sbnr() {
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');
    const [yfhdbt, setYfhdbt] = useState('')
    const [theProcess, setTheProcess] = useState('')
    const [returning, setReturning] = useState('')
    const {message, notification, modal} = App.useApp();
    const [form] = Form.useForm();
    const [研究开发活动] = Form.useForm();
    const [高新技术产品] = Form.useForm();
    const [知识产权汇总] = Form.useForm();
    const [科技人员] = Form.useForm();
    const [企业参与国家标准或行业标准制定情况明细] = Form.useForm();
    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };
    const {data: theMndsbData, loading: theMndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
            mndsb(where: {id: {_eq: $id}}) {
                FdeptCorCode
                SdeptCorCode
                TdeptCorCode
                GdeptCorCode
                YdeptCorCode
                year
                total_profit3
                total_profit2
                total_profit1
                sat_hr_tsdplan
                sat_hr_total
                sat_hr_part
                sat_hr_on_job
                sat_hr_forg
                sat_hr_ext
                sat_hr_abroed
                updated_at
                sales_revenue3
                sales_revenue2
                sales_revenue1
                net_asset3
                net_asset2
                net_asset1
                id
                enterprise_income
                ent_hr_tsdplan
                ent_hr_total
                ent_hr_senior
                ent_hr_primary
                ent_hr_part
                ent_hr_on_job
                ent_hr_middle
                ent_hr_mechanic
                ent_hr_master
                ent_hr_junior
                ent_hr_forg
                ent_hr_ext
                ent_hr_doctor
                ent_hr_bachelor
                ent_hr_age4
                ent_hr_age3
                ent_hr_age2
                ent_hr_age1
                ent_hr_abroed
                created_at
                companyObj {
                    clsj
                    created_at
                    id
                    qymc
                    tyshxydm
                    updated_at
                }
                company
                china_cost
                basics_cost
                _zscqjz
                _kjcgzh
                _glykj
                _jscxgl
                research_developments(order_by: {hcod: asc}) {
                    PHxjs
                    PLxmd
                    PQdcg
                    created_at
                    dataEprPJssj
                    dataEprPQzsj
                    hcod
                    id
                    mndsb
                    spending
                    updated_at
                    yproductName
                    zc3
                    zc2
                    zc1
                    players{
                        id
                        playerObj {
                            IDNumber
                            age
                            created_at
                            id
                            mndsb
                            name
                            number
                            post
                            professional
                            school
                            updated_at
                            xueli
                        }
                    }
                }
                gxjscps {
                    PGjjszb
                    PJzys
                    PZscqqk
                    Psfzycpstatus
                    cod
                    created_at
                    id
                    mndsb
                    productName
                    shr
                    technologyS
                    updated_at
                }
                zccqhzs {
                    created_at
                    id
                    mndsb
                    propertyAccredit
                    propertyCategory
                    propertyName
                    propertyNo
                    propertyWay
                    txtDate
                    updated_at
                }
                kffymxs {
                    created_at
                    fillUser
                    fillUserDate
                    id
                    mndsb
                    nbyjkftr
                    nwhj
                    orderNo
                    pjnwbtrhj
                    qtfy
                    ryrg
                    sjf
                    sbtsf
                    wtwbyjkftr
                    updated_at
                    zjtr
                    zjfy
                    xmbh
                    wxzc
                    yearsAgo
                    research_development
                }
                players {
                    IDNumber
                    age
                    created_at
                    id
                    mndsb
                    name
                    number
                    post
                    professional
                    school
                    updated_at
                    xueli
                }

                hyzdmxs {
                    blevel
                    bname
                    bnumber
                    created_at
                    id
                    mndsb
                    pway
                    updated_at
                }
                attachments {
                    created_at
                    description
                    id
                    item
                    name
                    path
                    text
                    updated_at
                }
                process(order_by: {created_at: asc}) {
                    comment
                    created_at
                    id
                    mndsb
                    name
                    operator
                    passed
                    updated_at
                    type
                }
            }
        }`, {
            variables: {id: value},
            shouldResubscribe: true
        },
    );
    const [insert_rdrygl] = useMutation(gql`
        mutation MyMutation($objects: [rdrygl_insert_input!] = {}) {
            insert_rdrygl(objects: $objects) {
                returning {
                    id
                }
            }
        }
    `);
    const [delete_rdrygl] = useMutation(gql`
        mutation MyMutation($where: rdrygl_bool_exp = {}) {
            delete_rdrygl(where: $where) {
                returning {
                    id
                }
            }
        }
    `);
    const [update_mndsb_by_pk, {error}] = useMutation(gql`
        mutation MyMutation($id: uuid = "", $mndsb: mndsb_set_input = {}) {
            update_mndsb_by_pk(pk_columns: {id: $id}, _set: $mndsb) {
                id
            }
        }
    `);
    const [delete_research_development_by_pk] = useMutation(gql`
        mutation MyMutation($id: uuid = "") {
            delete_research_development_by_pk(id: $id) {
                id
            }
        }
    `);
    const [delete_gxjscp_by_pk] = useMutation(gql`
        mutation MyMutation($id: uuid = "") {
            delete_gxjscp_by_pk(id: $id) {
                id
            }
        }
    `);
    const [delete_hyzdmx_by_pk] = useMutation(gql`
        mutation MyMutation($id: uuid = "") {
            delete_hyzdmx_by_pk(id: $id) {
                id
            }
        }
    `);
    const [delete_kffymx_by_pk] = useMutation(gql`
        mutation MyMutation($id: uuid = "") {
            delete_kffymx_by_pk(id: $id) {
                id
            }
        }
    `);
    const [delete_player_by_pk] = useMutation(gql`
        mutation MyMutation($id: uuid = "") {
            delete_player_by_pk(id: $id) {
                id
            }
        }
    `);
    const [delete_zccqhz_by_pk] = useMutation(gql`
        mutation MyMutation($id: uuid = "") {
            delete_zccqhz_by_pk(id: $id) {
                id
            }
        }
    `);
    const [insert_process] = useMutation(gql`
        mutation MyMutation($objects: [process_insert_input!] = {}) {
            insert_process(objects: $objects) {
                returning {
                    id
                }
            }
        }
    `);

    const getFields = () => {
        const children = [];
        for (let i = 0; i < 16; i++) {
            children.push(
                <Col span={i % 4 === 0 ? 3 : 7} key={i}>
                    {[5, 6, 7, 9, 10, 11, 13, 14, 15].indexOf(i) >= 0 ? <Form.Item
                        name={近三年经营情况字段[[5, 6, 7, 9, 10, 11, 13, 14, 15].indexOf(i)]}
                        // label={`Field ${i}`}
                        rules={[
                            {
                                required: true,
                                message: '请输入内容！',
                            },
                        ]}
                    >
                        <Input placeholder="请输入"/>

                    </Form.Item> : <>{['', '净资产', '销售收入', '利润总额', parseInt(theMndsbData.mndsb[0].year) - 3, '', '', '', parseInt(theMndsbData.mndsb[0].year) - 2, '', '', '', parseInt(theMndsbData.mndsb[0].year) - 1][i]}</>}
                </Col>,
            );
        }
        return children;
    };
    const mndsbInitialValues = {...(theMndsbData || {mndsb: []}).mndsb[0]};
    if ((theMndsbData || {}).mndsb) {
        for (let k of 申报表主表所有万元金额字段) {
            if ((theMndsbData || {}).mndsb[0][k]) {
                mndsbInitialValues[k] = money10000ToString((theMndsbData || {}).mndsb[0][k])
            }
        }
    }

    const yfhdColumns = [
        {
            title: '研发活动编号 RD',
            dataIndex: 'hcod',
            key: 'hcod',
        },
        {
            title: '研发活动名称',
            dataIndex: 'yproductName',
            key: 'yproductName',
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/yfhd?' + _
                }}>填写</a>
            ),
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    delete_research_development_by_pk({
                            variables: {
                                id: record.id
                            }
                        }
                    )


                }}>删除</a>
            ),

        }
    ];
    const kffymxColumns = [
        {
            title: '研发活动编号 RD',
            dataIndex: 'hcod',
            key: 'hcod',
        },
        {
            title: '研发活动名称',
            dataIndex: 'yproductName',
            key: 'yproductName',
        },
        {
            title: '开始日期',
            dataIndex: 'dataEprPQzsj',
            key: 'dataEprPQzsj',
            render: (_, recoder) => _ ? new Date(_).toLocaleDateString() : '未填写'
        },
        {
            title: '结束日期',
            dataIndex: 'dataEprPJssj',
            key: 'dataEprPJssj',
            render: (_, recoder) => _ ? new Date(_).toLocaleDateString() : '未填写'
        },
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        // },
        {
            title: '年度',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <Space>
                    {[3, 2, 1].map(yearsAgo => {
                            if ((new Date(record.dataEprPQzsj).getFullYear() <= (parseInt(theMndsbData.mndsb[0].year) - yearsAgo)) && (new Date(record.dataEprPJssj).getFullYear() >= (parseInt(theMndsbData.mndsb[0].year) - yearsAgo))) {
                                return <a onClick={(event) => {
                                    console.log(theMndsbData)
                                    console.log(yearsAgo, _, record)
                                    const theKffymx = ((theMndsbData || {}).mndsb || [])[0].kffymxs.filter(kffymx => kffymx.yearsAgo === yearsAgo && kffymx.research_development === _)
                                    console.log(((theMndsbData || {}).mndsb || [])[0].kffymxs)
                                    if (theKffymx.length > 0) {
                                        //TODO
                                        console.log(theKffymx)
                                        window.location.hash = '/kffymx?' + theKffymx[0].id


                                    } else {
                                        insert_kffymx_one({
                                                variables: {
                                                    yearsAgo,
                                                    research_development: _,
                                                    mndsb: value
                                                }
                                            }
                                        ).then(value => {
                                            console.log(value)
                                            window.location.hash = '/kffymx?' + value.data.insert_kffymx_one.id
                                        })

                                    }
                                    // window.location.hash = '/yfhd?' + _
                                }}>{parseInt(theMndsbData.mndsb[0].year) - yearsAgo}</a>
                            }
                        }
                    )}
                </Space>
            ),
        },
        // {
        //     title: '操作',
        //     dataIndex: 'id',
        //     key: 'action',
        //     render: (_, record) => (
        //         <a onClick={(event) => {
        //             delete_research_development_by_pk({
        //                     variables: {
        //                         id:record.id
        //                     }
        //                 }
        //             )
        //
        //
        //         }}>删除</a>
        //     ),
        //
        // }
    ];
    const gxjscpColumns = [
        {
            title: '高新技术产品编号 ps',
            dataIndex: 'cod',
            key: 'cod',
        },
        {
            title: '高新技术产品名称',
            dataIndex: 'productName',
            key: 'productName',
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/gxcp?' + _
                }}>填写</a>
            ),

        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    delete_gxjscp_by_pk({
                            variables: {
                                id: record.id
                            }
                        }
                    )
                }}>删除</a>
            ),

        },

    ];
    const zccqhzColumns = [
        {
            title: '知识产权编号：IP',
            dataIndex: 'propertyNo',
            key: 'propertyNo',
        },
        {
            title: '知识产权名称',
            dataIndex: 'propertyName',
            key: 'propertyName',
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/zccqhz?' + _
                }}>填写</a>
            ),
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    delete_zccqhz_by_pk({
                        variables: {
                            id: record.id
                        }
                    })
                }}>删除</a>
            ),

        }
    ];
    // const kffymxColumns = [
    //     {
    //         title: '项目编号',
    //         dataIndex: 'xmbh',
    //         key: 'xmbh',
    //     },
    //     {
    //         title: 'ID',
    //         dataIndex: 'id',
    //         key: 'id',
    //     },
    //     {
    //         title: '操作',
    //         dataIndex: 'id',
    //         key: 'action',
    //         render: (_, record) => (
    //             <a onClick={(event) => {
    //                 window.location.hash = '/kffymx?' + _
    //             }}>填写</a>
    //         ),
    //     },
    //     {
    //         title: '操作',
    //         dataIndex: 'id',
    //         key: 'action',
    //         render: (_, record) => (
    //             <a onClick={(event) => {
    //                 delete_kffymx_by_pk({
    //                     variables: {
    //                         id: record.id
    //                     }
    //                 })
    //             }}>删除</a>
    //         ),
    //
    //     }
    // ];
    const playerColumns = [
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '年龄',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: '学历',
            dataIndex: 'xueli',
            key: 'xueli',
        },
        {
            title: '毕业学校',
            dataIndex: 'school',
            key: 'school',
        },
        {
            title: '职称',
            dataIndex: 'professional',
            key: 'professional',
        },
        {
            title: '身份证号',
            dataIndex: 'IDNumber',
            key: 'IDNumber',
        },
        {
            title: '手机',
            dataIndex: 'number',
            key: 'number',
        },
        {
            title: '工作岗位',
            dataIndex: 'post',
            key: 'post',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/rlzy?' + _
                }}>填写</a>
            ),
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    delete_player_by_pk({
                        variables: {
                            id: record.id
                        }
                    })
                }}>删除</a>
            ),

        }
    ];
    const hyzdmxColumns = [
        {
            title: '标准编号',
            dataIndex: 'bnumber',
            key: 'bnumber',
        },
        {
            title: '标准名称',
            dataIndex: 'bname',
            key: 'bname',
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/hyzdmx?' + _
                }}>填写</a>
            ),
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    delete_hyzdmx_by_pk({
                        variables: {
                            id: record.id
                        }
                    })
                }}>删除</a>
            ),

        }
    ];

    const [insert_research_development, {insert_research_development_error}] = useMutation(gql`mutation MyMutation($hcod: String = "", $mndsb: uuid = "", $yproductName: String = "") {
        insert_research_development_one(object: {mndsb: $mndsb, hcod: $hcod, yproductName: $yproductName}) {
            id
        }
    }`);
    const [insert_research_developments, {insert_research_developments_error}] = useMutation(gql`mutation MyMutation($objects: [research_development_insert_input!] = {}) {
        insert_research_development(objects: $objects) {
            affected_rows
            returning {
                id
            }
        }
    }`);
    const [insert_gxjscp_one, {insert_gxjscp_one_error}] = useMutation(gql`
        mutation MyMutation($cod: String = "", $productName: String = "", $mndsb: uuid = "") {
            insert_gxjscp_one(object: {cod: $cod, productName: $productName, mndsb: $mndsb}) {
                id
            }
        }
    `)
    const [insert_zccqhz_one, {insert_zccqhz_one_error}] = useMutation(gql`
        mutation MyMutation($mndsb: uuid = "", $propertyName: String = "", $propertyNo: String = "") {
            insert_zccqhz_one(object: {mndsb: $mndsb, propertyName: $propertyName, propertyNo: $propertyNo}) {
                id
            }
        }
    `)
    const [insert_hyzdmx_one, {insert_hyzdmx_one_error}] = useMutation(gql`
        mutation MyMutation($mndsb: uuid = "", $bnumber: String = "",$bname: String="") {
            insert_hyzdmx_one(object: {mndsb: $mndsb, bnumber: $bnumber ,bname:$bname}) {
                id
            }
        }

    `)
    const [insert_player_one, {insert_player_one_error}] = useMutation(gql`
        mutation MyMutation($mndsb: uuid = "", $IDNumber:String = "" , $age: Int = 10, $name: String = "", $number: String = "", $post: String = "", $professional: String = "", $school: String = "", $xueli: String = "") {
            insert_player_one(object: {mndsb: $mndsb, IDNumber: $IDNumber, age: $age, name: $name, number: $number, post: $post, professional: $professional, school: $school, xueli: $xueli}) {
                id
            }
        }
    `)
    const [insert_kffymx_one, {insert_kffymx_one_error}] = useMutation(gql`
        mutation MyMutation($mndsb: uuid = "", $yearsAgo: Int = 10, $research_development: uuid = "") {
            insert_kffymx_one(object: {mndsb: $mndsb, yearsAgo: $yearsAgo, research_development: $research_development}) {
                id
            }
        }
    `)
    const stepsItems = [
        ...(theMndsbData || {mndsb: [{process: []}]}).mndsb[0].process.map(process => {
            return {
                title: process.type,
                description: new Date(process.created_at).toLocaleString(),
                status: process.passed ? null : 'error',
                // subTitle:
                onClick: () => {
                    modal.info({
                        title: process.type,
                        content: <><p>{process.comment}</p><p>{new Date(process.created_at).toLocaleString()}</p></>,
                        // placement: 'topLeft',
                    })
                }
            }
        })
    ]
    switch (((theMndsbData || {mndsb: [{process: []}]}).mndsb[0].process.slice(-1)[0] || {name: '企业基本信息填写'}).name) {
        case "企业基本信息填写":
            stepsItems.push({
                title: "企业基本信息填写",
            })
        case "企业基本信息填写完成":
            stepsItems.push({
                title: "系统审核",
            })
        case "中介研发项目完成":
            stepsItems.push({
                title: "财务信息填写",
            })
        case "财务信息填写完成":
            stepsItems.push({
                title: "系统审核",
            })
        case "立项书生成完成":
            stepsItems.push({
                title: "材料盖章上传",
            })
        case "材料盖章上传完成":
            stepsItems.push({
                title: "系统审核",
            })
        case "项目申报完成":
            stepsItems.push({
                title: "申报完成",
            })
    }
    useEffect(() => {
        setTheProcess(((theMndsbData || {mndsb: [{process: []}]}).mndsb[0].process.slice(-1)[0] || {name: '企业基本信息填写'}).name)
    }, [theMndsbData])
    const inputs = (form) => [
        ['知识产权对企业竞争力的作用 (限400字) ', '_zscqjz', `请帮我编写${(theMndsbData).mndsb[0].companyObj.qymc}知识产权对企业竞争力的作用（限400字）`],
        ['科技成果转化情况 (限400字) ', '_kjcgzh', `请帮我编写${(theMndsbData).mndsb[0].companyObj.qymc}科技成果转化情况（限400字）`],
        ['研究开发与技术创新组织管理情况 (限400字) ', '_jscxgl', `请帮我编写${(theMndsbData).mndsb[0].companyObj.qymc}研究开发与技术创新组织管理情况（限400字）`],
        ['管理与科技人员情况 (限400字) ', '_glykj', `请帮我编写${(theMndsbData).mndsb[0].companyObj.qymc}管理与科技人员情况（限400字）`],
    ]
    return (<>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <label title={'申报 ID'} style={{width: '70px'}}>申报 ID：</label>
            <Input value={value} onChange={(e) => {
                handleChange(e.target.value)
            }}/>
        </div>
        <div style={{padding: '10px'}}></div>
        {(theMndsbData || {}).mndsb && <>
            <Descriptions title="" bordered>
                <Descriptions.Item label="企业名称" span={2}>{theMndsbData.mndsb[0].companyObj.qymc}</Descriptions.Item>
                <Descriptions.Item label="申报年度" span={2}>{theMndsbData.mndsb[0].year}</Descriptions.Item>
                <Descriptions.Item label="统一社会信用代码"
                                   span={2}>{theMndsbData.mndsb[0].companyObj.tyshxydm}</Descriptions.Item>
                <Descriptions.Item
                    label="成立时间"
                    span={2}>{new Date(theMndsbData.mndsb[0].companyObj.clsj).toLocaleDateString()}</Descriptions.Item>
            </Descriptions>
            <div style={{padding: '10px'}}></div>
            <Collapse defaultActiveKey={stepsItems.length > 7 ? [] : ['1']} ghost>
                <Panel header="申报流程" key="1">
                    <Steps
                        size={stepsItems.length > 7 ? 'default' : 'small'}
                        current={theMndsbData.mndsb[0].process.length}
                        items={stepsItems}
                        direction={stepsItems.length > 7 ? 'vertical' : 'horizontal'}
                    />
                </Panel>
            </Collapse>
            {theProcess === '企业基本信息填写完成' && <>
                <Paragraph>
                    <h4>资料审核</h4>
                    1、检查企业填写信息准确：包括企业基本信息、知识产权、高新技术产品、人员信息。<br/>
                    2、生成研发项目。<br/>
                    3、通过审核。
                </Paragraph>
                {/*<div style={{padding: '10px'}}></div>*/}
                <Space>
                    <Button type="primary" onClick={() => {
                        insert_process({
                            variables: {
                                objects: [{name: "中介研发项目完成", mndsb: value, comment: "", type: "审核通过"}]
                            }
                        })
                    }}>
                        通过审核
                    </Button>
                    <Button type="primary" danger onClick={() => {
                        setReturning('企业基本信息填写')
                    }}>
                        退回资料
                    </Button>
                </Space>


            </>}
            {theProcess === '中介研发项目完成' && <>
                <div style={{padding: '10px'}}></div>
                <Space>
                    <Button type="primary" danger onClick={() => {
                        insert_process({
                            variables: {
                                objects: [{
                                    name: "企业基本信息填写完成",
                                    mndsb: value,
                                    comment: "",
                                    type: "撤销审核",
                                    passed: false
                                }]
                            }
                        })
                    }}>
                        撤销审核
                    </Button>
                </Space>
            </>}
            {theProcess === '财务信息填写完成' && <>
                <Paragraph>
                    <h4>资料审核</h4>
                    1、检查企业填写信息准确。<br/>
                    2、生成立项书。<br/>
                    3、通过审核。
                </Paragraph>
                {/*<div style={{padding: '10px'}}></div>*/}
                <Space>
                    <Button type="primary" onClick={() => {
                        insert_process({
                            variables: {
                                objects: [{name: "立项书生成完成", mndsb: value, comment: "", type: "审核通过"}]
                            }
                        })
                    }}>
                        通过审核
                    </Button>
                    <Button type="primary" danger onClick={() => {
                        setReturning('中介研发项目完成')
                    }}>
                        退回资料
                    </Button>
                </Space>


            </>}
            {theProcess === '立项书生成完成' && <>
                <div style={{padding: '10px'}}></div>
                <Space>
                    <Button type="primary" danger onClick={() => {
                        insert_process({
                            variables: {
                                objects: [{
                                    name: "财务信息填写完成",
                                    mndsb: value,
                                    comment: "",
                                    type: "撤销审核",
                                    passed: false
                                }]
                            }
                        })
                    }}>
                        撤销审核
                    </Button>
                </Space>
            </>}
            {theProcess === '材料盖章上传完成' && <>
                <Paragraph>
                    <h4>资料审核</h4>
                    1、检查企业填写信息准确。<br/>
                    2、完成项目申报。<br/>
                    3、通过审核。
                </Paragraph>
                {/*<div style={{padding: '10px'}}></div>*/}
                <Space>
                    <Button type="primary" onClick={() => {
                        insert_process({
                            variables: {
                                objects: [{name: "项目申报完成", mndsb: value, comment: "", type: "审核通过"}]
                            }
                        })
                    }}>
                        通过审核
                    </Button>
                    <Button type="primary" danger onClick={() => {
                        setReturning('立项书生成完成')
                    }}>
                        退回资料
                    </Button>
                </Space>
            </>}
            {theProcess === '项目申报完成' && <>
                <div style={{padding: '10px'}}></div>
                <Space>
                    <Button type="primary" danger onClick={() => {
                        insert_process({
                            variables: {
                                objects: [{
                                    name: "材料盖章上传完成",
                                    mndsb: value,
                                    comment: "",
                                    type: "撤销审核",
                                    passed: false
                                }]
                            }
                        })
                    }}>
                        撤销审核
                    </Button>
                </Space>
            </>}
            {returning && <>
                <div style={{padding: '10px'}}></div>
                <Form
                    name="basic"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    style={{maxWidth: 600}}
                    layout="vertical"
                    initialValues={{remember: true}}
                    onFinish={(values) => {
                        insert_process({
                            variables: {
                                objects: [{
                                    name: returning,
                                    mndsb: value,
                                    comment: values.comment,
                                    type: "退回资料",
                                    passed: false
                                }]
                            }
                        }).then(() => {
                            setReturning('')
                        })
                    }
                    }
                    onFinishFailed={(e) => {
                        console.error(e)
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="退回原因"
                        name="comment"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <TextArea showCount autoSize={{minRows: 2}}/>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 0, span: 16}}>
                        <Space>
                            <Button type="primary" danger htmlType="submit">
                                确认退回
                            </Button>
                            <Button onClick={() => {
                                setReturning('')
                            }}>
                                取消操作
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </>}
            <h4>科技人员</h4>
            <Form
                form={科技人员}
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{maxWidth: 600}}
                initialValues={{remember: true}}
                onFinish={(values) => {
                    insert_player_one({
                            variables: {
                                ...values,
                                mndsb: value
                            }
                        }
                    ).fankui().then(value1 => 科技人员.resetFields())
                }
                }
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
            >
                <Form.Item
                    label="姓名"
                    name="name"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="年龄"
                    name="age"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <InputNumber/>
                </Form.Item>
                <Form.Item
                    label="学历"
                    name="xueli"
                    rules={[{required: true, message: '请选择内容'}]}
                >
                    <Select>
                        <Select.Option value="研究生">研究生</Select.Option>
                        <Select.Option value="本科">本科</Select.Option>
                        <Select.Option value="大专">大专</Select.Option>
                        <Select.Option value="大专以下">大专以下</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="毕业学校"
                    name="school"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="职称"
                    name="professional"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Select>
                        <Select.Option value="高级职称">高级职称</Select.Option>
                        <Select.Option value="中级职称">中级职称</Select.Option>
                        <Select.Option value="初级职称">初级职称</Select.Option>
                        <Select.Option value="高级技工">高级技工</Select.Option>
                        <Select.Option value="无">无</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="身份证号"
                    name="IDNumber"
                    rules={[{required: true, message: '请输入正确内容', type: "string", len: 18}]}
                >
                    <Input maxLength={18}/>
                </Form.Item>
                <Form.Item
                    label="手机"
                    name="number"
                    rules={[{required: true, message: '请输入正确内容', type: "string", len: 11}]}
                >
                    <Input maxLength={11}/>
                </Form.Item>
                <Form.Item
                    label="工作岗位"
                    name="post"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item wrapperCol={{offset: 8, span: 16}}>
                    <Button type="primary" htmlType="submit">
                        新增科技人员
                    </Button>
                </Form.Item>
            </Form>
            <Paragraph>
                <h5>温馨提示</h5>
                1. 科技人员数量不低于企业职工总数的10%<br/>
                2. 科技人员不包括行政、销售、财务岗位<br/>
                3. 科技人员工作时长需要满183天以上<br/>
                4. 临时聘用或兼职的科技人员需要提供兼职劳动合同
            </Paragraph>
            <Table columns={playerColumns} dataSource={theMndsbData.mndsb[0].players}/>
            <h4>科技人员分配</h4>
            {theMndsbData.mndsb[0].research_developments.reduce((a, rd) => a.concat(...rd.players.map(p => p.playerObj)), []).length === 0 &&

                <Form
                    name="basic"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    style={{maxWidth: 600}}
                    initialValues={{remember: true}}
                    onFinish={(values) => {
                        const objects = []
                        theMndsbData.mndsb[0].research_developments.map(rd => {
                            theMndsbData.mndsb[0].players.sort(function () {
                                return Math.random() - 0.5;
                            }).slice(0, Math.round(Math.random() * values.sjsfrs + values.mgyfhdrs)).map((ry, index) => {
                                objects.push({player: ry.id, research_development: rd.id, rank: index})
                            })
                        })
                        insert_rdrygl({
                            variables: {
                                objects
                            }
                        })
                    }
                    }
                    onFinishFailed={(e) => {
                        console.error(e)
                    }}
                    autoComplete="off"
                >
                    <p>当前研发活动数量：{theMndsbData.mndsb[0].research_developments.length} 个</p>
                    <p>当前科技人员数量：{theMndsbData.mndsb[0].players.length} 人</p>
                    <p>每个研发活动人数 + 随机上浮人数 不得超过 {theMndsbData.mndsb[0].players.length}</p>
                    <Form.Item
                        label="每个研发活动人数"
                        name="mgyfhdrs"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <InputNumber style={{
                            width: '100%',
                        }}/>
                    </Form.Item>
                    <Form.Item
                        label="随机上浮人数"
                        name="sjsfrs"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <InputNumber style={{
                            width: '100%',
                        }}/>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 8, span: 16}}>
                        <Button type="primary" htmlType="submit">
                            随机分配研发人员
                        </Button>
                    </Form.Item>
                </Form>
            }
            {theMndsbData.mndsb[0].research_developments.reduce((a, rd) => a.concat(...rd.players.map(p => p.playerObj)), []).length > 0 && <>
                <Button type="primary" danger onClick={() => {
                    const _or = theMndsbData.mndsb[0].research_developments.reduce((a, rd) => a.concat(...rd.players.map(p => p)), []).map(p => {
                        return {id: {'_eq': p.id}}
                    })
                    delete_rdrygl({
                        variables: {
                            where: {_or}
                        }
                    })
                }}>
                    撤销研发人员分配
                </Button>
                {theMndsbData.mndsb[0].research_developments.map(rd => <>
                    <p>{rd.yproductName}</p>
                    <Space>{rd.players.map(p => <Tag color="default">{p.playerObj.name}</Tag>)}</Space>
                </>)}</>}
            <h4>研究开发活动</h4>
            <Form
                form={研究开发活动}
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{maxWidth: 600}}
                initialValues={{remember: true}}
                onFinish={(values) => {
                    insert_research_development({
                            variables: {
                                ...values,
                                mndsb: value,
                            },
                        }
                    ).fankui().then(value1 => 研究开发活动.resetFields())
                }
                }
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
            >
                <Form.Item
                    label="研发活动编号 RD"
                    name="hcod"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="研发活动名称"
                    name="yproductName"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item wrapperCol={{offset: 8, span: 16}}>
                    <Button type="primary" htmlType="submit">
                        新增研发活动
                    </Button>
                </Form.Item>
            </Form>
            <p>自动生成研发活动名称（每行一个，只保留名称）</p>
            <Space>
                <Button onClick={() => {
                    chatAI(`请根据${theMndsbData.mndsb[0].gxjscps.map(k => `${k.productName} `)}相关的研究为我起十五个研发项目名称，后缀以研究或者应用结尾，不能出现机理、设计等字，例如：基于某技术某方法的研究`, yfhdbt, setYfhdbt)
                }}>
                    根据高新技术产品名称生成（ChatGPT）
                </Button>
                <Button onClick={() => {
                    chatAI(`请根据${theMndsbData.mndsb[0].gxjscps.map(k => `${k.productName} `)}相关的研究为我起十五个研发项目名称，后缀以研究或者应用结尾，不能出现机理、设计等字，例如：基于某技术某方法的研究`, yfhdbt, setYfhdbt, 'bing')
                }}>
                    根据高新技术产品名称生成（Bing）
                </Button>
                <Button onClick={() => {
                    setYfhdbt(yfhdbt.split('\n').filter(title => title.indexOf('. ') > 0).map(title => title.slice(title.indexOf('. ') + 2)).join('\n'))
                }}>
                    尝试只保留名称（ChatGPT）
                </Button>
                <Button onClick={() => {
                    setYfhdbt(yfhdbt.split('\n').filter(title => title.indexOf('- ') === 0).map(title => title.slice(2)).join('\n'))
                }}>
                    尝试只保留名称（Bing）
                </Button>
            </Space>
            <div style={{padding: '10px'}}></div>
            <TextArea value={yfhdbt} onChange={(e) => setYfhdbt(e.target.value)} autoSize/>
            <div style={{padding: '10px'}}></div>
            <Space>
                <Button type={"primary"} onClick={() => {
                    insert_research_developments({
                        variables: {
                            objects: yfhdbt.split('\n').map((yproductName, index) => {
                                return {
                                    yproductName,
                                    hcod: (index + 1).toString().padStart(2, '0'),
                                    mndsb: value
                                }
                            })
                        }
                    })
                }}>
                    提交
                </Button>
            </Space>
            <div style={{padding: '10px'}}></div>
            <Table columns={yfhdColumns} dataSource={theMndsbData.mndsb[0].research_developments}/>
            <h4>高新技术产品</h4>
            <Form
                form={高新技术产品}
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{maxWidth: 600}}
                initialValues={{remember: true}}
                onFinish={(values) => {
                    insert_gxjscp_one({
                            variables: {
                                ...values,
                                mndsb: value
                            }
                        }
                    ).fankui().then(value1 => {
                        高新技术产品.resetFields()
                        window.location.hash = '/gxcp?' + value1.data.insert_gxjscp_one.id
                    })
                }
                }
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
            >
                <Form.Item
                    label="编号 PS"
                    name="cod"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input placeholder="例如：01"/>
                </Form.Item>
                <Form.Item
                    label="产品（服务）名称"
                    name="productName"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input placeholder="企业主营产品（服务），例如：智慧路灯"/>
                </Form.Item>
                <Form.Item wrapperCol={{offset: 8, span: 16}}>
                    <Button type="primary" htmlType="submit">
                        新增高新技术产品
                    </Button>
                </Form.Item>
            </Form>
            <Table columns={gxjscpColumns} dataSource={theMndsbData.mndsb[0].gxjscps}/>
            <h4>知识产权汇总</h4>
            <Form
                form={知识产权汇总}
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{maxWidth: 600}}
                initialValues={{remember: true}}
                onFinish={(values) => {
                    insert_zccqhz_one({
                            variables: {
                                ...values,
                                mndsb: value
                            }
                        }
                    ).fankui().then(value1 => {
                        知识产权汇总.resetFields()
                        window.location.hash = '/zccqhz?' + value1.data.insert_zccqhz_one.id
                    })
                }
                }
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
            >
                <Form.Item
                    label="知识产权编号"
                    name="propertyNo"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="知识产权名称"
                    name="propertyName"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item wrapperCol={{offset: 8, span: 16}}>
                    <Button type="primary" htmlType="submit">
                        新增知识产权
                    </Button>
                </Form.Item>
            </Form>
            <Table columns={zccqhzColumns} dataSource={theMndsbData.mndsb[0].zccqhzs}/>
            <h4>企业年度研究开发费用结构明细</h4>
            {/*<Form*/}
            {/*    name="basic"*/}
            {/*    labelCol={{span: 8}}*/}
            {/*    wrapperCol={{span: 16}}*/}
            {/*    style={{maxWidth: 600}}*/}
            {/*    initialValues={{remember: true}}*/}
            {/*    onFinish={(values) => {*/}
            {/*        insert_kffymx_one({*/}
            {/*                variables: {*/}
            {/*                    ...values,*/}
            {/*                    mndsb: value*/}
            {/*                }*/}
            {/*            }*/}
            {/*        )*/}
            {/*    }*/}
            {/*    }*/}
            {/*    onFinishFailed={(e) => {*/}
            {/*        console.error(e)*/}
            {/*    }}*/}
            {/*    autoComplete="off"*/}
            {/*>*/}
            {/*    <Form.Item*/}
            {/*        label="项目编号"*/}
            {/*        name="xmbh"*/}
            {/*        rules={[{required: true, message: '请输入内容'}]}*/}
            {/*    >*/}
            {/*        <Input/>*/}
            {/*    </Form.Item>*/}
            {/*    <Form.Item wrapperCol={{offset: 8, span: 16}}>*/}
            {/*        <Button type="primary" htmlType="submit">*/}
            {/*            新增开发费用明细*/}
            {/*        </Button>*/}
            {/*    </Form.Item>*/}
            {/*</Form>*/}
            <Table columns={kffymxColumns} dataSource={theMndsbData.mndsb[0].research_developments}/>
            <h4>企业创新能力</h4>
            <Form
                name="basic"
                labelCol={{
                    span: 32,
                }}
                wrapperCol={{
                    span: 32,
                }}
                style={{
                    maxWidth: 900,
                }}
                layout="vertical"
                initialValues={mndsbInitialValues}
                // layout={'inline'}
                onFinish={(values) => {
                    update_mndsb_by_pk({variables: {id: theMndsbData.mndsb[0].id, mndsb: values}})
                    // insert_mndsb({variables: {year: e.year.$y, company: theCompanyData.company[0].id}})
                }}
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
                form={form}
            >

                <Space>
                    <Button onClick={() => {
                        inputs(form).map(i => chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer)))
                    }}>一键 ChatGPT</Button>
                    <Button onClick={() => {
                        inputs(form).map(i => chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer)), 'bing')
                    }}>一键 Bing</Button>
                </Space>
                {inputs(form).map((i, index) => <>
                    <Form.Item
                        label={i[0]}
                        name={i[1]}
                        rules={[{required: true, message: i[0]}]}
                    >
                        <TextArea showCount autoSize/>
                    </Form.Item>
                    <Space>
                        <Button onClick={() => {
                            const i = inputs(form)[index]
                            chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer))
                        }}>ChatGPT</Button>
                        <Button onClick={() => {
                            const i = inputs(form)[index]
                            chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer), 'bing')
                        }}>Bing</Button>
                    </Space>
                </>)}

                <Form.Item wrapperCol={{offset: 8, span: 8}}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                </Form.Item>
            </Form>

            {/*<h4>企业年度研究开发费用结构明细</h4>*/}
            {/*<Table columns={yfhdColumns} dataSource={theMndsbData.mndsb[0].research_developments}/>*/}
            {/*<Form*/}
            {/*    name="basic"*/}
            {/*    labelCol={{span: 8}}*/}
            {/*    wrapperCol={{span: 16}}*/}
            {/*    style={{maxWidth: 600}}*/}
            {/*    initialValues={{remember: true}}*/}
            {/*    onFinish={(values) => {*/}
            {/*        insert_kffymx_one({*/}
            {/*            variables: {*/}
            {/*                ...values,*/}
            {/*                    mndsb: value*/}
            {/*                }*/}
            {/*            }*/}
            {/*        )*/}
            {/*    }*/}
            {/*    }*/}
            {/*    onFinishFailed={(e) => {*/}
            {/*        console.error(e)*/}
            {/*    }}*/}
            {/*    autoComplete="off"*/}
            {/*>*/}
            {/*    <Form.Item*/}
            {/*        label="项目编号"*/}
            {/*        name="xmbh"*/}
            {/*        rules={[{required: true, message: '请输入内容'}]}*/}
            {/*    >*/}
            {/*        <Input/>*/}
            {/*    </Form.Item>*/}
            {/*    <Form.Item wrapperCol={{offset: 8, span: 16}}>*/}
            {/*        <Button type="primary" htmlType="submit">*/}
            {/*            新增开发费用明细*/}
            {/*        </Button>*/}
            {/*    </Form.Item>*/}
            {/*</Form>*/}
            {/*<Table columns={kffymxColumns} dataSource={theMndsbData.mndsb[0].kffymxs}/>*/}
            <h4>近三年经营情况（万元）</h4>
            <Form
                name="basic"
                labelCol={{
                    span: 32,
                }}
                wrapperCol={{
                    span: 32,
                }}
                style={{
                    maxWidth: 900,
                }}
                initialValues={mndsbInitialValues}
                // layout={'inline'}
                onFinish={(values) => {
                    for (let k of 申报表主表所有万元金额字段) {
                        if (values[k]) {
                            values[k] = string10000ToMoney(values[k])
                        }
                    }
                    update_mndsb_by_pk({variables: {id: theMndsbData.mndsb[0].id, mndsb: values}})
                    // insert_mndsb({variables: {year: e.year.$y, company: theCompanyData.company[0].id}})
                }}
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
            >

                <Row gutter={24}>{getFields()}</Row>

                <Form.Item
                    label="在中国境内研发费用总额（万元）"
                    name="china_cost"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="基础研究投入费用总额（万元）"
                    name="basics_cost"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="近一年企业总收入（万元）"
                    name="enterprise_income"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item wrapperCol={{offset: 8, span: 8}}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                </Form.Item>
            </Form>
            <h3>近三年财务审计报告</h3>
            <div className='shenji'>
                <h3 style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textIndent: "2vw"
                }}>{parseInt(theMndsbData.mndsb[0].year) - 3}年财务审计报告</h3>
                {/*<div className='search' style={{padding: '0,0,20vw,10vw', display: 'inline-block'}}>*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构统一社会信用代码"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 400,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}

                {/*        }}*/}
                {/*    />*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构名称"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 300,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}

                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
            <SelectUpload
                item={value}
                nameList={['财务审计报告']}
                description="3年前财务审计报告"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="3年前财务审计报告"/>

            <div className='shenji'>
                <h3 style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textIndent: "2vw"
                }}>{parseInt(theMndsbData.mndsb[0].year) - 2}年财务审计报告</h3>
                {/*<div className='search' style={{padding: '0,0,20vw,10vw', display: 'inline-block'}}>*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构统一社会信用代码"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 400,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}

                {/*        }}*/}
                {/*    />*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构名称"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 300,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
            <SelectUpload
                item={value}
                nameList={['财务审计报告']}
                description="2年前财务审计报告"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="2年前财务审计报告"/>
            <div className='shenji'>
                <h3 style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textIndent: "2vw"
                }}>{parseInt(theMndsbData.mndsb[0].year) - 1}年财务审计报告</h3>
                {/*<div className='search' style={{padding: '0,0,20vw,10vw', display: 'inline-block'}}>*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构统一社会信用代码"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 400,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}

                {/*        }}*/}
                {/*    />*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构名称"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 300,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
            <SelectUpload
                item={value}
                nameList={['财务审计报告']}
                description="1年前财务审计报告"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="1年前财务审计报告"/>
            <Paragraph>
                请上传具有资质的中介机构鉴证的企业近三个会计年度（实际年限不足三年的按实际经营年限）财务会计报告（包括会计报表、会计报表附注和财务情况说明书）。 <br/>
                <h5>认定机构具体要求如下：</h5>
                1.
                近三年企业财务审计报表，包含资产负债表、利润表、现金流量表、审计单位营业执照、执业证书、资格证书等。<br/>
                <h5>附件格式要求：</h5>
                1、证明材料扫描上传。<br/>
                2、只支持非加密PDF格式的文件上传。<br/>
                3、单个文件大小不要超过8M。
            </Paragraph>
            <h3>近一年高新产品（服务）收入专项审计报告</h3>
            {/*<div className='search' style={{padding: '0,0,20vw,10vw', display: 'inline-block'}}>*/}
            {/*    <Search*/}
            {/*        placeholder="审计机构统一社会信用代码"*/}
            {/*        allowClear*/}
            {/*        enterButton="查询"*/}
            {/*        size="middle"*/}
            {/*        onSearch={onSearch}*/}
            {/*        style={{*/}
            {/*            width: 400,*/}
            {/*            verticalAlign: 'middle',*/}
            {/*            padding: '3vw'*/}

            {/*        }}*/}
            {/*    />*/}
            {/*    <Search*/}
            {/*        placeholder="审计机构名称"*/}
            {/*        allowClear*/}
            {/*        enterButton="查询"*/}
            {/*        size="middle"*/}
            {/*        onSearch={onSearch}*/}
            {/*        style={{*/}
            {/*            width: 300,*/}
            {/*            verticalAlign: 'middle',*/}
            {/*            padding: '3vw'*/}
            {/*        }}*/}
            {/*    />*/}
            {/*</div>*/}
            <SelectUpload
                item={value}
                nameList={['专项审计报告']}
                description="近一年高新产品（服务）收入专项审计报告"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments}
                         description="近一年高新产品（服务）收入专项审计报告"/>
            <Paragraph>
                请上传经具有资质并符合《工作指引》相关条件的中介机构出具的企业近一个会计年度高新技术产品（服务）收入专项审计或鉴证报告。 <h5>认定机构具体要求如下：</h5>
                1. 近一年的高新产品（服务）收入明细表，编制说明、审计单位营业执照、执业证书、资格证书等。<br/>
                2. 企业自行选择推荐名单以外的其他省区审计机构，须中介机构所在地注册会计师协会出具符合条件的证明材料及诚信承诺书。<br/>
                <h5>附件格式要求：</h5>
                1、证明材料扫描上传。<br/>
                2、只支持非加密PDF格式的文件上传。<br/>
                3、单个文件大小不要超过5M。
            </Paragraph>
            <div className='shenji'>
                <h3>近三年研发费用专项审计报告</h3>
                {/*<div className='search' style={{padding: '0', display: 'inline-block'}}>*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构统一社会信用代码"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 400,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}

                {/*        }}*/}
                {/*    />*/}
                {/*    <Search*/}
                {/*        placeholder="审计机构名称"*/}
                {/*        allowClear*/}
                {/*        enterButton="查询"*/}
                {/*        size="middle"*/}
                {/*        onSearch={onSearch}*/}
                {/*        style={{*/}
                {/*            width: 300,*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            padding: '3vw'*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
            <SelectUpload
                item={value}
                nameList={['专项审计报告']}
                description="近三年研发费用专项审计报告"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="近三年研发费用专项审计报告"/>
            <Paragraph>
                请上传经具有资质并符合《工作指引》相关条件的中介机构出具的企业近三个会计年度
                （实际年限不足三年的按实际经营年限）研究开发费用专项审计或鉴证报告(并附研究开发活动说明材料)。
                <h5>认定机构具体要求如下：</h5>
                1. 近三年研发项目情况表、近三年研究开发费用支出汇总表、研发费用结构明细表及编制说明、情况说明等。<br/>
                2. 企业自行选择推荐名单以外的其他省区审计机构，须中介机构所在地注册会计师协会出具符合条件的证明材料及诚信承诺书（只提供一次即可，无须重复提供）。<br/>
                <h5>附件格式要求：</h5>
                1、证明材料扫描上传。<br/>
                2、只支持非加密PDF格式的文件上传。<br/>
                3、单个文件大小不要超过5M。
            </Paragraph>

            <h4>企业参与国家标准或行业标准制定情况明细</h4>
            <Form
                form={企业参与国家标准或行业标准制定情况明细}
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{maxWidth: 600}}
                initialValues={{remember: true}}
                onFinish={(values) => {
                    insert_hyzdmx_one({
                            variables: {
                                ...values,
                                mndsb: value
                            }
                        }
                    ).fankui().then(value1 => 企业参与国家标准或行业标准制定情况明细.resetFields())
                }
                }
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
            >
                <Form.Item
                    label="标准编号"
                    name="bnumber"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="标准名称"
                    name="bname"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item wrapperCol={{offset: 8, span: 16}}>
                    <Button type="primary" htmlType="submit">
                        新增标准制定情况
                    </Button>
                </Form.Item>
            </Form>
            <Table columns={hyzdmxColumns} dataSource={theMndsbData.mndsb[0].hyzdmxs}/>

            <h3>附件 <UploadOutlined/></h3>

            <h3>营业执照</h3>
            <SelectUpload
                item={value}
                nameList={['营业执照']}
                description="营业执照"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="营业执照"/>
            <Paragraph>
                说明：请上传加盖公章的营业执照扫描件，大小不超过500KB
            </Paragraph>
            <h3>申请书封皮</h3>
            <SelectUpload
                item={value}
                nameList={['申请书封皮']}
                description="申请书封皮"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="申请书封皮"/>
            <Paragraph>
                说明：请上传系统自动生成的申请书封皮盖章后的扫描件
            </Paragraph>
            <h3>近一年1月～12月的社保缴纳证明、企业职工工资表</h3>
            <SelectUpload
                item={value}
                nameList={['近一年1月～12月的社保缴纳证明', '近一年1月～12月的企业职工工资表']}
                description="近一年1月～12月的社保缴纳证明、企业职工工资表"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments}
                         description="近一年1月～12月的社保缴纳证明、企业职工工资表"/>
            <Paragraph>
                <h5>认定机构具体要求如下：</h5>
                1. 近一年1月～12月的社保缴纳证明、企业职工工资表；<br/>
                2. 加盖单位公章；<br/>
                <h5>附件格式要求：</h5>

                1、证明材料扫描上传。<br/>

                2、只支持非加密PDF格式的文件上传。<br/>

                3、单个文件大小不要超过2M。
            </Paragraph>

            <h3>近三年企业所得税纳税申报表</h3>
            <h3 style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                textIndent: "2vw"
            }}>{parseInt(theMndsbData.mndsb[0].year) - 3}年企业纳税申报表</h3>
            <SelectUpload
                item={value}
                nameList={['企业纳税申报表']}
                description="3年前企业纳税申报表"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="3年前企业纳税申报表"/>
            <h3 style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                textIndent: "2vw"
            }}>{parseInt(theMndsbData.mndsb[0].year) - 2}企业所得税纳税申报表</h3>
            <SelectUpload
                item={value}
                nameList={['企业纳税申报表']}
                description="2年前企业纳税申报表"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="2年前企业纳税申报表"/>
            <h3 style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                textIndent: "2vw"
            }}>{parseInt(theMndsbData.mndsb[0].year) - 1}企业所得税纳税申报表</h3>
            <SelectUpload
                item={value}
                nameList={['企业纳税申报表']}
                description="1年前企业纳税申报表"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="1年前企业纳税申报表"/>
            <Paragraph>
                请上传企业近三个会计年度（实际年限不足三年的按实际经营年限）企业所得税年度纳税申报表（包括主表及附表）。
                <h5>认定机构具体要求如下：</h5>
                1. 近三年企业所得税年度纳税申报表，包括企业所得税年度纳税申报表填报表单、企业基础信息表、一般企业收入明细表、一般企业成本支出明细表、
                期间费用明细表、视同销售和房地产开发企业特定业务纳税调整明细表、职工薪酬纳税调整明细表、广告费和业务宣传费跨年度纳税调整明细表、资产折旧/摊销情况及纳税调整明细表、固定资产加速折旧/扣除明细表、资产损失税前扣除及纳税调整明细表、
                资产损失（专项申报）税前扣除及纳税调整明细表、企业所得税弥补亏损明细表、免税/减计收入及加计扣除优惠明细表、研发费用加计扣除优惠明细表、减免所得税优惠明细表、
                高新技术企业优惠情况及明细表、纳税调整项目明细表，企业所得税年度纳税申报表、企业年度关联业务往来报告表，重点户企业财务报表（年报）等。<br/>
                <h5>附件格式要求：</h5>
                1、证明材料扫描上传。<br/>
                2、只支持非加密PDF格式的文件上传。<br/>
                3、单个文件大小不要超过5M。
            </Paragraph>

            <h3>认定机构要求上传的其他附件</h3>
            <SelectUpload
                item={value}
                nameList={['荣誉资质', '信用报告', '设备图片', '各类生产许可证', '资质证书', '其他附件']}
                description="其他附件"
            />
            <Attachments attachments={theMndsbData.mndsb[0].attachments} description="其他附件"/>
            <Paragraph>
                <h5>认定机构具体要求如下：</h5>
                如荣誉资质、信用报告、设备图片、各类生产许可证以及资质证书等<br/>
                <h5>附件格式要求：</h5>
                1、证明材料扫描上传。<br/>
                2、只支持非加密PDF格式的文件上传。<br/>
                3、单个文件大小不要超过5M。
            </Paragraph>

        </>}
    </>)
}
